import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './plugins/vuex'
import './plugins/naffto'
import './plugins/mapbox'
import './plugins/baseComponents'
import router from './plugins/vue-router'
import App from './App.vue'
import store from './store/index'
import VueSimpleSVG from 'vue-simple-svg'

import '../src/secondred-theme/app.sass'

Vue.use(VueSimpleSVG)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  beforeCreate () {
    this.$store.commit('geoview/initialise')
    this.$store.commit('layer/initialise')
    this.$store.commit('search/initialise')
  },
  render: h => h(App)
}).$mount('#app')
